import React from "react";
import PermissionGuard from "../../components/PermissionGuard";

const Dashboard: React.FC = () => {
  return (
    <PermissionGuard module="dashboard" action="read">
      <div className="p-6 pt-0">
        <h1 className="text-2xl text-[#212121] tracking-[-0.5px]">
          Dashboard
        </h1>
      </div>
    </PermissionGuard>
  );
};

export default Dashboard;
